export default "__VITE_ASSET__BmuEp4W6__"